import { forwardRef, useEffect } from "react";
import L from "leaflet";
import "leaflet.browser.print/dist/leaflet.browser.print.min.js";

const LeafletBrowserPrint = forwardRef(({ ...rest }, ref) => {
  const map = ref?.current?.leafletElement;

  useEffect(() => {
    if (!map) return;

    const browserPrintMap = L.control
      .browserPrint({
        ...rest,
      })
      .addTo(map);

    return () => map.removeControl(browserPrintMap);
  }, [map]);

  return null;
});

export default LeafletBrowserPrint;
